/* eslint-disable radix, default-case, arrow-body-style, no-param-reassign, prefer-template */
import Quizzes from 'es6/controllers/apps/quizzes';
import StudyNode from 'es6/models/study-node';

function getSettingsVariable(setting) {
  return typeof Smartfm !== 'undefined'
         && Smartfm.Apps
         && Smartfm.Apps.Settings
         && Smartfm.Apps.Settings[setting];
}

/**
 * @returns {Boolean}
 */
export function isDebugModeEnabled() {
  return getSettingsVariable('StealthMode');
}

/**
 * @returns {Boolean}
 */
export function checkDiscardData() {
  return !!getSettingsVariable('DiscardData');
}

export function checkAllOverrides(sessionData) {
  checkForcedContent(sessionData);
  checkForcedQuizType(sessionData);
  checkSingleItemSession(sessionData);
}

export function checkForcedContent(sessionData) {
  const forcedItem = parseInt(getSettingsVariable('ForcedItem'));

  if (!forcedItem) {
    return;
  }

  // Just replicate the first study node and use that data to produce
  // the forced item.
  const StudyNodeAttributes = Object.assign({}, sessionData.studySession[0]);
  const contentDomain = StudyNodeAttributes.contentDomain;

  let contentPool = {};
  switch (contentDomain) {
    case 'items':
      contentPool = sessionData.itemPackages;
      break;
    case 'sentences':
      contentPool = sessionData.sentences;
      break;
  }

  // Grab the appropriate content from the content pool.
  const content = contentPool[forcedItem];
  if (!content) {
    throw new Error(`Content with ID: ${forcedItem} does not exist in this course!`);
  }

  // Grab the appropriate memory.
  const memory = sessionData.memories.find(d => {
    return d.contentDomain === contentDomain && d.contentId === content.getId();
  });

  // Update the attributes for the study node.
  Object.assign(StudyNodeAttributes, {
    contentId: content.getId(),
    content,
    memory,
  });

  sessionData.studySession[0] = new StudyNode(StudyNodeAttributes);
}

export function checkForcedQuizType(sessionData) {
  if (Smartfm && Smartfm.Apps.Settings.ForcedQuiz) {
    const quizName = Smartfm.Apps.Settings.ForcedQuiz;
    const forced = Quizzes[quizName];
    if (forced) {
      _.each(sessionData.studySession, function (studyNode) {
        studyNode.quizSequence = [quizName];
      });
    } else {
      throw new Error('Unknown QuizType ' + quizName + ' specified as override.');
    }
  }
}

// Checks to see if the forced achievements flag is set and if it is, returns
// the appropriate achievements fixture.
export function checkForcedAchievement() {
  const forcedAchievement = getSettingsVariable('ForcedAchievement');
  const achievementFixtures = getSettingsVariable('AchievementFixtures');

  return forcedAchievement && achievementFixtures && achievementFixtures[forcedAchievement - 1];
}

export function checkSingleItemSession(sessionData) {
  if (Smartfm && Smartfm.Apps.Settings.SingleItemSession) {
    sessionData.studySession = _.take(sessionData.studySession, 1);
  }
}

// Forced completion can only happen once, set a flag.
let forcedCompletion = false;
export function checkForcedCompletion() {
  const retVal = !forcedCompletion && getSettingsVariable('ForcedCompletion');

  // Make sure this doesn't get checked again.
  forcedCompletion = true;

  return retVal;
}

export function checkForcedCheckpoint() {
  return getSettingsVariable('ForcedCheckpoint');
}

// TODO: Remove this if we expose debugging options in some other way on only
// non-production builds using envify.
// Returns the pause delay setting in milliseconds.
export function getPauseDelay() {
  return getSettingsVariable('PauseDelay') * 1000;
}

export default checkAllOverrides;
